import {
  fallbackText,
  getDataFromLink,
  Prismic,
  PrismicLink,
} from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { CardGroup } from '../components/card-group/CardGroup';
import { RelatedCard } from '../components/card/RelatedCard';

interface IProps {
  fields: IField[];
}

interface IField {
  title: Prismic.RichText;
  copy: Prismic.RichText;
  link: Prismic.Link & any;
  style?: any;
  icon?: string;
}

const CardItem = ({ title, copy, link, style, icon }: IField, i: number) => {
  const linkdata = getDataFromLink(link);
  const heroTitle = link?.body?.filter((x: any) => x.type === 'hero')[0]
    ?.primary?.title;

  const boxTitle = fallbackText(title, linkdata.title ?? undefined);
  const boxDescription = fallbackText(copy, heroTitle);

  return (
    <PrismicLink value={link} title={boxTitle ?? undefined} key={i}>
      <RelatedCard
        key={`related-${i}-${Prismic.text(title)}`}
        title={boxTitle}
        description={boxDescription}
        theme="primary"
        style={style}
        icon={icon}
      />
    </PrismicLink>
  );
};

export const RelatedContainer = ({ fields }: IProps) => {
  if (fields.length === 0) {
    return null;
  }

  const fLength = fields.length;
  const count = fLength <= 3 ? 3 : 4;

  return (
    <Segment>
      <CardGroup columns={count}>
        {fields?.map((item, index) => (
          <CardItem key={index} {...item} />
        ))}
      </CardGroup>
    </Segment>
  );
};
